import api from '../../utils/api'

export const state = {}

export const mutations = {}

export const actions = {
  async handleCreate(_, body) {
    try {
      return await api.post('/whatsapp-message', body)
    } catch (e) {

    }
  },

  async handleUpdate(_, body) {
    try {
      return await api.put(`/whatsapp-message/${body._id}`, body)
    } catch (e) {

    }
  },

  async handleGet(_, _id) {
    try {
      return await api.get(`/whatsapp-message/${_id}`)
    } catch (e) {

    }
  },

  async handleDelete(_, _id) {
    try {
      return await api.delete(`/whatsapp-message/${_id}`)
    } catch (e) {

    }
  },

  async handlePagedList(_, payload) {
    try {

      const params = new URLSearchParams()
      if (payload.page) {
        params.set('page', payload.page)
      }
      if (payload.limit) {
        params.set('limit', payload.limit)
      }
      if (payload.triggerTag) {
        params.set('triggerTags', payload.triggerTag)
      }

      const { data: response } = await api.get(`/whatsapp-message?${params.toString()}`)
      return response
    } catch (e) {

    }
  },

  async handleLogsPagedList(_, payload) {
    try {
      const params = new URLSearchParams()
      if (payload.page) {
        params.set('page', payload.page)
      }
      if (payload.limit) {
        params.set('limit', payload.limit)
      }
      if (payload.phone) {
        params.set('phone', payload.phone)
      }
      if (payload.status) {
        params.set('status', payload.status)
      }
      if (payload.triggerTag) {
        params.set('triggerTag', payload.triggerTag)
      }
      if (payload.whatsAppMessage) {
        params.set('whatsAppMessage', payload.whatsAppMessage)
      }

      const { data: response } = await api.get(`/whatsapp-message/logs?${params.toString()}`)
      return response
    } catch (e) {

    }
  },

  async handleLogsSummary(_, payload) {
    try {
      const params = new URLSearchParams()
      if (payload.phone) {
        params.set('phone', payload.phone)
      }
      if (payload.triggerTag) {
        params.set('triggerTag', payload.triggerTag)
      }
      if (payload.whatsAppMessage) {
        params.set('whatsAppMessage', payload.whatsAppMessage)
      }

      const { data: response } = await api.get(`/whatsapp-message/logs/summary?${params.toString()}`)
      return response
    } catch (e) {

    }
  },

  async handleSendInBatch(_, body) {
    try {
      return await api.post(`/whatsapp-message/send-batch`, body)
    } catch (e) {

    }
  },

  async handleSendTest(_, body) {
    try {
      return await api.post(`/whatsapp-message/send-test`, body)
    } catch (e) {

    }
  },

  async handleGetWhatsAppTemplates() {
    try {
      return await api.get('/whatsapp-message/templates')
    } catch (e) {

    }
  }
}

export const getters = {}
